import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export class PriceService {
  static getProducts() {
    return RetailerApiClient.get('prices')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static getProductsByQuery(query) {
    return RetailerApiClient.get('prices', {
      params: query
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static savePrices(params) {
    return RetailerApiClient.post('prices/batch-store', params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static savePrice(params) {
    return RetailerApiClient.post('prices', params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static getMobilePrice(params) {
    return RetailerApiClient.post('prices/get-mobile-product-price-info', params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static getPurchaseOfferPrice(params) {
    return RetailerApiClient.post('prices/get-mobile-product-price-info-for-offer', params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
